import React, { useState } from 'react';
import { Scale, ChevronDown, ChevronUp, BookOpen } from 'lucide-react';
import { processCitations } from '../../../../utils/textFormat';

/**
 * AI 답변 하단에 법령 근거와 원문을 표시하는 공통 컴포넌트
 * @param {Array} citations - 상세 법령 원문 배열 (예: [{ title: "산업안전보건법", source: "제1조...", snippet: "..." }])
 */

const CitationBlock = ({ lawRefs = [], citations = [] }) => {
    const [isExpanded, setIsExpanded] = useState(false);

    // 참고한 법령 데이터가 없으면 렌더링하지 않음
    if (!citations || citations.length === 0) return null;

    const processedCitations = processCitations(citations);
    const uniqueRefs = Array.from(new Set(processedCitations.map(c => `${c.title} ${c.source}`)));

    return (
        <div className="mt-4 pt-4 border-t border-gray-200/60">
            {/* 1. 요약 태그 영역 (뱃지) */}
            <div className="mb-3">
                <div className="flex items-center gap-1.5 text-xs font-bold text-blue-700 mb-2">
                    <Scale size={14} />
                    <span>관련 법령 근거</span>
                </div>
                <div className="flex flex-wrap gap-1.5">
                    {uniqueRefs.map((refText, idx) => (
                        <span
                            key={idx}
                            className="px-2.5 py-1 bg-white text-blue-600 rounded-md text-[11px] font-medium border border-blue-100 shadow-sm"
                        >
                            {refText}
                        </span>
                    ))}
                </div>
            </div>

            {/* 2. 상세 원문 아코디언 영역 */}
            <div className="mt-3">
                <button
                    onClick={() => setIsExpanded(!isExpanded)}
                    className="flex items-center gap-1 text-[11px] text-gray-500 hover:text-blue-600 transition-colors bg-white px-3 py-2 rounded-lg w-full justify-between border border-gray-100 shadow-sm"
                >
                    <span className="flex items-center gap-1.5 font-medium">
                        <BookOpen size={12} className={isExpanded ? "text-blue-500" : "text-gray-400"} />
                        관련 조문 원문 확인
                    </span>
                    {isExpanded ? <ChevronUp size={14} /> : <ChevronDown size={14} />}
                </button>

                {/* 펼쳐지는 상세 원문 내용 */}
                {isExpanded && (
                    <div className="mt-2 space-y-2 animate-fade-in">
                        {processedCitations.map((cite, idx) => (
                            <div key={idx} className="p-3 bg-[#f8fafc] rounded-xl border border-gray-200">
                                <h5 className="text-xs font-bold text-gray-700 mb-1">
                                    {cite.title} {cite.source}
                                </h5>
                                <p className="text-[11px] text-gray-600 leading-relaxed whitespace-pre-wrap">
                                    "{cite.snippet}"
                                </p>
                            </div>
                        ))}
                    </div>
                )}
            </div>
        </div>
    );
};

export default CitationBlock;
